export const PlusIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5 5.5h-1v6h-6v1h6v6h1v-6h6v-1h-6v-6z" fill="#fff" />
    </svg>
  );
};
